import api from "./api";
import { tokenStorage } from "../utils/tokenStorage";
import { buildCredentialToken } from "../utils/encryption";

const AuthService = {
  /**
   * Logs the user in. The backend authenticates purely off the
   * encrypted "X-My-Secret-Token" header (no request body), and that
   * same encrypted string is reused afterwards as the session token
   * for every other request (profile, check-in, check-out).
   */
  async login(username, password) {
    const credentialToken = buildCredentialToken(username, password);

    const { data } = await api.post("/Login/Login", undefined, {
      headers: { "X-My-Secret-Token": credentialToken },
    });

    return { ...data, credentialToken };
  },

  /**
   * Fetches the logged-in user's profile.
   * Explicitly sends the X-My-Secret-Token header created at login time
   * (read from tokenStorage) - this is the same token that must be sent
   * on every check-in / check-out call.
   */
  async getProfile() {
    const token = tokenStorage.get();
    if (!token) {
      throw new Error("You're not logged in. Please sign in again.");
    }

    const { data } = await api.post("/QrRetrieve/RetrieveDataById", undefined, {
      headers: { "X-My-Secret-Token": token },
    });
    const profile = JSON.parse(data.responceMessage);

    return {
      firstName: profile.First_Name,
      lastName: profile.Last_Name,
      userName: profile.User_Name,
    };
  },
};

export default AuthService;
